import { ChangeEvent } from 'react';
import { TextField, Grid, InputAdornment } from '@mui/material';
import FrequencySelect from '../../components/FrequencySelect';
import { MarkerIndex, ParsedMarker } from './types';

interface Props {
  markers: ParsedMarker[];
  markerAmplitudes: number[];
  handleMarkerInputClicked: (idx: MarkerIndex) => void;
  handleMarkerValueChanged: (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    idx: MarkerIndex
  ) => void;
  handleMarkerUnitChanged: (event: any, index: MarkerIndex) => void;
  disabled?: boolean;
}
const MarkerConfigurationInputs = ({
  markers,
  markerAmplitudes,
  handleMarkerInputClicked,
  handleMarkerValueChanged,
  handleMarkerUnitChanged,
  disabled,
}: Props) => {
  return (
    <Grid container item spacing={1}>
      <Grid item xs={4} style={{ minWidth: '7rem' }}>
        <TextField
          id='marker1'
          label='Marker 1'
          InputLabelProps={{ style: { color: 'rgb(255,255,255)' } }}
          type='number'
          name='marker1'
          inputProps={{ min: -1 }}
          placeholder='Marker 1'
          value={
            markers[0]?.x_pos_frequency_value >= 0
              ? markers[0]?.x_pos_frequency_value
              : ''
          }
          onClick={() => handleMarkerInputClicked(0)}
          onChange={(event) => handleMarkerValueChanged(event, 0)}
          variant='outlined'
          size='small'
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={2} style={{ minWidth: '6rem' }}>
        <FrequencySelect
          selected={markers[0]?.x_pos_frequency_unit || 'MHz'}
          onChange={(event) => handleMarkerUnitChanged(event, 0)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={4} style={{ minWidth: '9.3rem' }}>
        <TextField
          id='marker1Value'
          name='marker1Value'
          placeholder='Amplitude'
          value={markerAmplitudes[0] || ''}
          variant='outlined'
          size='small'
          InputProps={{
            endAdornment: <InputAdornment position='end'>dBm</InputAdornment>,
          }}
          disabled={disabled}
        />
      </Grid>
      <Grid item container spacing={1}>
        <Grid item xs={4} style={{ minWidth: '7rem' }}>
          <TextField
            id='marker2'
            label='Marker 2'
            InputLabelProps={{ style: { color: 'rgb(255,255,0)' } }}
            type='number'
            inputProps={{ min: -1 }}
            name='marker2'
            placeholder='Marker 2'
            value={
              markers[1]?.x_pos_frequency_value >= 0
                ? markers[1]?.x_pos_frequency_value
                : ''
            }
            onClick={() => handleMarkerInputClicked(1)}
            onChange={(event) => handleMarkerValueChanged(event, 1)}
            variant='outlined'
            size='small'
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={2} style={{ minWidth: '6rem' }}>
          <FrequencySelect
            selected={markers[1]?.x_pos_frequency_unit || 'MHz'}
            onChange={(event) => handleMarkerUnitChanged(event, 1)}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={4} style={{ minWidth: '9.3rem' }}>
          <TextField
            id='marker2Value'
            name='marker2Value'
            placeholder='Amplitude'
            value={markerAmplitudes[1] || ''}
            variant='outlined'
            size='small'
            InputProps={{
              endAdornment: <InputAdornment position='end'>dBm</InputAdornment>,
            }}
            disabled={disabled}
          />
        </Grid>
      </Grid>
      <Grid item xs={4} style={{ minWidth: '7rem' }}>
        <TextField
          id='marker3'
          label='Marker 3'
          InputLabelProps={{ style: { color: 'rgb(255,0,0)' } }}
          type='number'
          inputProps={{ min: -1 }}
          name='marker3'
          placeholder='Marker 3'
          value={
            markers[2]?.x_pos_frequency_value >= 0
              ? markers[2]?.x_pos_frequency_value
              : ''
          }
          onClick={() => handleMarkerInputClicked(2)}
          onChange={(event) => handleMarkerValueChanged(event, 2)}
          variant='outlined'
          size='small'
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={2} style={{ minWidth: '6rem' }}>
        <FrequencySelect
          selected={markers[2]?.x_pos_frequency_unit || 'MHz'}
          onChange={(event) => handleMarkerUnitChanged(event, 2)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={4} style={{ minWidth: '9.3rem' }}>
        <TextField
          id='marker3Value'
          name='marker3Value'
          placeholder='Amplitude'
          variant='outlined'
          size='small'
          value={markerAmplitudes[2] || ''}
          InputProps={{
            endAdornment: <InputAdornment position='end'>dBm</InputAdornment>,
          }}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={4} style={{ minWidth: '7rem' }}>
        <TextField
          id='marker4'
          label='Marker 4'
          InputLabelProps={{ style: { color: 'rgb(0,255,255)' } }}
          type='number'
          inputProps={{ min: -1 }}
          name='marker4'
          placeholder='Marker 4'
          value={
            markers[3]?.x_pos_frequency_value >= 0
              ? markers[3]?.x_pos_frequency_value
              : ''
          }
          onClick={() => handleMarkerInputClicked(3)}
          onChange={(event) => handleMarkerValueChanged(event, 3)}
          variant='outlined'
          size='small'
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={2} style={{ minWidth: '6rem' }}>
        <FrequencySelect
          selected={markers[3]?.x_pos_frequency_unit || 'MHz'}
          onChange={(event) => handleMarkerUnitChanged(event, 3)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={4} style={{ minWidth: '9.3rem' }}>
        <TextField
          id='marker4Value'
          name='marker4Value'
          placeholder='Amplitude'
          value={markerAmplitudes[3] || ''}
          variant='outlined'
          size='small'
          InputProps={{
            endAdornment: <InputAdornment position='end'>dBm</InputAdornment>,
          }}
          disabled={disabled}
        />
      </Grid>
    </Grid>
  );
};

export default MarkerConfigurationInputs;
